import DashboardBookings from '@/components/Pages/Dashboard/DashboardBookings.vue';
import DashboardVendors from '@/components/Pages/Dashboard/DashboardVendors.vue';
import DashboardServices from '@/components/Pages/Dashboard/DashboardServices.vue';
import DashboardCategories from '@/components/Pages/Dashboard/DashboardCategories.vue';
import DashboardImages from '@/components/Pages/Dashboard/DashboardImages.vue';
import DashboardApplications from '@/components/Pages/Dashboard/DashboardApplications.vue';
import DashboardSettings from '@/components/Pages/Dashboard/DashboardSettings.vue';
import VendorSignUp from '@/components/Pages/Vendor/VendorSignUp.vue';
import DashboardVendorProfile from '@/components/Pages/Dashboard/DashboardVendorProfile.vue';
import DashboardCustomers from '@/components/Pages/Dashboard/DashboardCustomers.vue';
import DashboardOrders from '@/components/Pages/Dashboard/DashboardOrders.vue';
import DashboardDirectory from '@/components/Pages/Dashboard/DashboardDirectory.vue';

export default [
    {
        path: '',
        name: 'dashboard',
        component: DashboardDirectory,
        meta: {
            roles: ['admin', 'vendor'],
        },
    },
    {
        path: 'bookings',
        name: 'bookings',
        component: DashboardBookings,
        meta: {
            roles: ['admin', 'vendor'],
        },
    },
    {
        path: 'bookings/:booking',
        name: 'booking',
        component: DashboardBookings,
        meta: {
            roles: ['admin', 'vendor'],
        },
    },
    {
        path: 'vendors',
        name: 'vendors',
        component: DashboardVendors,
        meta: {
            roles: ['admin'],
        },
    },
    {
        path: 'services',
        name: 'services',
        component: DashboardServices,
        meta: {
            roles: ['admin'],
        },
    },
    {
        path: 'categories',
        name: 'categories',
        component: DashboardCategories,
        meta: {
            roles: ['admin'],
        },
    },
    {
        path: 'profile',
        name: 'profile',
        component: DashboardVendorProfile,
        meta: {
            roles: ['vendor'],
        },
    },
    {
        path: 'settings',
        name: 'settings',
        component: DashboardSettings,
        meta: {
            roles: ['admin'],
        },
    },
    {
        path: 'customers',
        name: 'customers',
        component: DashboardCustomers,
        meta: {
            roles: ['admin'],
        },
    },
    {
        path: 'customers/:purchaser',
        name: 'customer',
        component: DashboardCustomers,
        meta: {
            roles: ['admin'],
        },
    },
    {
        path: 'orders',
        name: 'orders',
        component: DashboardOrders,
        meta: {
            roles: ['admin'],
        },
    },
    {
        path: 'orders/:order',
        name: 'order',
        component: DashboardOrders,
        meta: {
            roles: ['admin'],
        },
    },
    {
        path: 'images',
        name: 'images',
        component: DashboardImages,
        meta: {
            roles: ['admin'],
        },
    },
    {
        path: 'applications',
        name: 'Applications',
        component: DashboardApplications,
        meta: {
            roles: ['admin'],
        },
    },
    {
        path: 'applications/:application',
        name: 'View Application',
        component: VendorSignUp,
        meta: {
            roles: ['admin'],
        },
    },
];
